export default {
	getHeaders(ctx) {
		return {
			field: [
				{ field: "created", 				title: ctx.$t('date') },
				{ field: "name", 					title: ctx.$t("name") },
				{ field: "chat_messages_count", 	title: "" },
				{ field: "status", 					title: ctx.$t("status") },
				{ field: "subject", 				title: ctx.$t("subject") },
				{ field: "work_type",		 		title: ctx.$t("type") },
				{ field: "quality_level", 			title: ctx.$t("level") },
				{ field: "pages_number", 			title: ctx.$t("pagesCount") },
				{ field: "due_date", 				title: ctx.$t("dueDate") },
				{ field: "author.username", 		title: ctx.$t("author") },
				{ field: "task", 					title: ctx.$t("task") },
			],

			tabs: [
				{
					key: "active",
					title: ctx.$t("activeOrders"),
					pages: [
						"client_not_answer",
						"processing",
						"waiting_payment",
						"waiting_author",
						"in_progress",
						"waiting_approve",
						"corrections",
					]
				},
				{
					key: "history",
					title: ctx.$t("ordersHistory"),
					pages: [
						"completed",
						"failed_with_payout",
						"failed",
					]
				}
			]
		}
	}
};
